import { BookingStatus } from '@rematter/frontend-lib-api-client';
import omit from 'lodash/omit';

import { simpleBookingFragment } from './fragmentsBooking';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { QueryAtomResult } from '~/shared/providers/api/createQueryAtomFactory';

export type BookingRecord = QueryAtomResult<
  typeof bookingListQueryAtom
>['bookings'][number];

export const bookingListQueryAtom = createQueryAtomFactory(
  'customerPortal.bookings',
  (params: {
    status: BookingStatus[];
    searchTerm?: string;
    pagination?: {
      limit: number;
      offset?: number;
    };
  }) => ({
    bookings: {
      __args: {
        filter: {
          status: params.status,
          searchTerm: params.searchTerm,
        },
        pagination: params.pagination
          ? {
              limit: params.pagination.limit,
              offset: params.pagination?.offset ?? 0,
            }
          : undefined,
      },
      page: {
        total: true,
      },
      entries: {
        ...simpleBookingFragment,
      },
    },
  }),
  {
    select: ({ bookings }) => ({
      total: bookings.page.total ?? 0,
      bookings: bookings.entries.map((booking) => ({
        ...omit(booking, ['salesOrders']),
        // TODO: map actual supplier
        supplier: {
          id: '1',
          name: 'Mock Supplier Inc.',
        },
        // TODO: map actual purchase orders
        purchaseOrders: booking.salesOrders,
      })),
    }),
  },
);
